module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/layout/layout-top-panel-1-d491b2cdfff323873ed88e523b4a95c2.svg";